import * as React from 'react';
import { Button, List, Thumbnail } from '@bynder/design-system';
import { IconMin, IconUser } from '@bynder/icons';

interface Props {
	id: string;
	email: string;
	name: string;
	onClear?: () => void;
}

export const UserResult = (props: Props) => <UserItem {...props} dataTestId="ooo-result-item" />;

export const UserSelected = (props: Props) => (
	<UserItem {...props} dataTestId="ooo-selected-item" />
);

const UserItem = (props: Props & { dataTestId: string }) => (
	<List.Item
		key={props.id}
		data-testid={props.dataTestId}
		thumbnail={<Thumbnail icon={<IconUser />} shape="circle" />}
		subtext={props.email}
		rightElements={
			props.onClear && (
				<Button
					variant="secondary"
					onClick={props.onClear}
					aria-label="Remove"
					icon={<IconMin />}
				/>
			)
		}
	>
		{props.name}
	</List.Item>
);
